import aboutCast from "../../assets/images/castsImages/aboutCast.png";
import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
import {
  Feather,
  Droplets,
  UserCheck,
  ShieldCheck,
  Activity,
  Sparkles,
  CheckCircle2,
  Wind
} from "lucide-react";

const leftFeatures = [
  {
    icon: Feather,
    text: "Comfortably lightweight",
  },
  {
    icon: Droplets,
    text: "Breathable yet waterproof",
  },
  {
    icon: UserCheck,
    text: "Customized for individual needs",
  },
  {
    icon: ShieldCheck,
    text: "Prevents scratching, infections, and pressure ulcers",
  },
];

const rightFeatures = [
  {
    icon: Activity,
    text: "Reduces muscle mass loss",
  },
  {
    icon: Sparkles,
    text: "Effortless to clean",
  },
  {
    icon: CheckCircle2,
    text: "Simple application and removal process",
  },
  {
    icon: Wind,
    text: "Prevents window edema",
  },
];

const ProductFeaturesShowcase = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className="relative bg-white overflow-hidden">

       <div className="max-w-3xl mx-auto text-center">
          <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
        <h2
          className="
            text-secondary font-semibold leading-tight
            text-[1.6rem]
            sm:text-[2.1rem]
            md:text-[2.5rem]
            lg:text-[2.8rem]
            xl:text-[3rem]
            mb-4 sm:mb-5
          "
        >
            Why <span className="text-primary">YESOAIR</span> is a Better Alternative
          </h2>
 </div>
          <p className="mt-8  text-gray-500 text-base">
            A modern approach to orthopedic casting designed for comfort,
            hygiene, and performance.
          </p>
         
        </div>
      <div className="max-w-7xl mx-auto mt-10">

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_520px_1fr] gap-20 items-center">

          {/* LEFT FEATURES */}
          <div className="space-y-8">
            {leftFeatures.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={i}
                  className="flex items-start gap-4 text-gray-700"
                >
                  <Icon
                    className="w-6 h-6 text-primary flex-shrink-0 mt-0.5"
                    strokeWidth={1.8}
                  />
                  <p className="text-[15px] leading-relaxed">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

          {/* CENTER IMAGE */}
          <div className="relative flex justify-center items-center">
            <div className="absolute w-[520px] h-[520px] bg-primary/20 blur-[140px] rounded-full" />
            <div className="absolute w-[280px] h-[280px] bg-primary/25 blur-[90px] rounded-full" />

            <img
              src={aboutCast}
              alt="YESOAIR Cast"
              className="
                relative z-10
                object-contain
                drop-shadow-[0_40px_70px_rgba(0,0,0,0.25)]
              "
            />
          </div>

          {/* RIGHT FEATURES */}
          <div className="space-y-8">
            {rightFeatures.map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={i}
                  className="flex items-start gap-4 text-gray-700"
                >
                  <Icon
                    className="w-6 h-6 text-primary flex-shrink-0 mt-0.5"
                    strokeWidth={1.8}
                  />
                  <p className="text-[15px] leading-relaxed">
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProductFeaturesShowcase;
